import {
  Directive,
  HostListener,
  Optional,
  Self
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'p-chips' // משפיע על כל p-chips בפרויקט
})
export class ChipsPasteHandlerDirective {
  constructor(@Optional() @Self() private ngControl: NgControl) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.ngControl?.control) return;

    event.preventDefault();

    const pastedData = event.clipboardData?.getData('text') || '';

    const items = pastedData
      .split(/\r?\n/)         // פיצול לפי שורות
      .map(s => s.trim())     // הסרת רווחים מיותרים
      .filter(s => !!s);      // סינון שורות ריקות

    const current = this.ngControl.control.value || [];

    const merged = [...current, ...items];

    this.ngControl.control.setValue(merged);
    this.ngControl.control.markAsDirty();
    this.ngControl.control.markAsTouched();
  }
}



